import React from 'react';
import Dribbble from '@/assets/dribbble.svg';
import GitHub from '@/assets/github.svg';
import LinkedIn from '@/assets/linkedin.svg';
import Instagram from '@/assets/instagram.svg';
import Facebook from '@/assets/facebook.svg';
import Link from '../../resolvers/Link';
import { cn } from '../../lib/cn';

const Social = [
  {
    icon: Dribbble,
    url: 'https://dribbble.com/cleancommit',
    sronly: "Clean Commit's dribbble",
  },
  {
    icon: GitHub,
    url: 'https://github.com/clean-commit',
    sronly: "Clean Commit's github",
  },
  {
    icon: LinkedIn,
    url: 'https://linkedin.com/company/cleancommit/',
    sronly: "Clean Commit's linkedin",
    eventId: 'ZDJ6ZZKX',
  },
  {
    icon: Facebook,
    url: 'https://www.facebook.com/cleancommit',
    sronly: "Clean Commit's facebook",
    eventId: false,
  },
  {
    icon: Instagram,
    url: 'https://www.instagram.com/clean_commit/',
    sronly: "Clean Commit's instagram",
    eventId: 'EWWSU3AI',
  },
];

export default function SocialLinks({ variant = 'default' }) {
  return (
    <>
      {Social &&
        Social.map((link, i) => (
          <SocialLink key={i} link={link} variant={variant} />
        ))}
    </>
  );
}

const SocialLink = ({ link, variant = 'default' }) => {
  const Icon = link.icon;
  return (
    <Link
      className='items-center justify-center px-3 py-2 text-gray-700 transition-colors hover:text-gray-300'
      to={link.url}>
      <Icon
        className={cn('fill-current', {
          'h-5 w-5': variant === 'small',
        })}
      />
      <div className='sr-only'>{link.sronly}</div>
    </Link>
  );
};
